<div [ngClass]="isOrderAssigned() ? 'order-info' : 'space-info'">
  <div class="main__header">
    <div class="main__header__back">
      <div class="main__header__back__button" id="go-back-button" (click)="goBack()">
        <span class="main__header__back__button__button-left-icon material-icons">
          chevron_left
        </span>
      </div>
    </div>
    <div>
      <span class="main__header__title" data-testid="space-detail-title">
        {{ 'common.spaceDetailTitle' | translate }} {{ positionLabel }}?
      </span>
    </div>
    <div class="main__header__right">
      <div
        class="main__header__right__button"
        data-testid="space-detail-nav-up-button"
        [ngClass]="{ disabled: currentIndex === 0 }"
      >
        <span
          (click)="updateSpace(previousDirection)"
          class="main__header__right__icon material-icons"
        >
          keyboard_arrow_up
        </span>
      </div>
      <div
        class="main__header__right__button"
        data-testid="space-detail-nav-down-button"
        [ngClass]="{ disabled: currentIndex === columnStructure.length - 1 }"
      >
        <span (click)="updateSpace(nextDirection)" class="main__header__right__icon material-icons">
          keyboard_arrow_down
        </span>
      </div>
    </div>
  </div>

  <div class="main__info-container">
    <div>
      <b>
        <span class="text" data-testid="space-detail-space-status-label">
          {{ 'common.spaceDetail.spaceStatus' | translate }}:
        </span>
        <span
          class="text"
          [ngClass]="isOrderAssigned() ? 'text__space-status' : 'text__disabled'"
          data-testid="space-detail-space-status-value"
          >{{ spaceState }}</span
        >
      </b>
    </div>
    <div class="main__info-container__general-info">
      <div>
        <b>
          <span class="text" data-testid="space-detail-order-status-label">
            {{ 'common.spaceDetail.orderStatus' | translate }}:
          </span>
          <span
            class="text"
            data-testid="space-detail-order-status-value"
            [ngClass]="isOrderAssigned() ? 'text__' + dispenseInfo?.state : 'text__disabled'"
          >
            {{ orderState | translate }}
          </span>
        </b>
      </div>
      <div *ngIf="isOrderAssigned()">
        <b>
          <span class="text" data-testid="space-detail-order-time-in-status-label">
            {{ 'common.spaceDetail.orderLockeddownTime' | translate }}:
          </span>
          <span
            class="text text__{{ dispenseInfo?.state }}"
            data-testid="space-detail-order-time-in-status-value"
          >
            {{ space.timer }}
          </span>
        </b>
      </div>
    </div>
    <div class="main__info-container__order-info" *ngIf="isOrderAssigned()">
      <span class="text" data-testid="space-detail-order-number">
        <b>{{ 'common.spaceDetail.orderNo' | translate }}: </b>
        {{ scheduleId }}
      </span>
      <span class="text" data-testid="space-detail-order-name">
        <b> {{ 'common.spaceDetail.name' | translate }}: </b>
        {{ scheduleName }}
      </span>
      <span class="text" data-testid="space-detail-order-description">
        <b> {{ 'common.spaceDetail.orderDescription' | translate }}: </b>
        {{ description }}
      </span>
    </div>
  </div>

  <div [ngClass]="showUpButtons() ? 'main__buttons-container' : 'main__buttons-container-single'">
    <div class="main__buttons-container__up" *ngIf="showUpButtons()">
      <button
        (click)="action(setActionByState('up-left').action)"
        [disabled]="!isUpLeftButtonEnabled()"
        class="main__buttons-container__button"
        data-testid="space-detail-up-left-button"
        [ngClass]="
          isUpLeftButtonEnabled()
            ? 'main__buttons-container__up__color'
            : 'main__buttons-container__disabled-color'
        "
      >
        {{ setActionByState('up-left').text | translate }}
      </button>
      <button
        (click)="action(setActionByState('up-right').action)"
        data-testid="space-detail-up-right-button"
        class="main__buttons-container__button main__buttons-container__up__color"
      >
        {{ setActionByState('up-right').text | translate }}
      </button>
    </div>
    <div class="main__buttons-container__down">
      <button
        (click)="action(setActionByState('down').action)"
        [disabled]="!isDownButtonEnabled()"
        class="main__buttons-container__button"
        data-testid="space-detail-down-center-button"
        [ngClass]="
          isDownButtonEnabled()
            ? 'main__buttons-container__down__color'
            : 'main__buttons-container__disabled-color'
        "
      >
        {{ setActionByState('down').text | translate }}
      </button>
    </div>
  </div>

  <div class="main__footer">
    <frodo-logo [src]="logo" [alt]="logoAlt"></frodo-logo>
  </div>
</div>
